import { Sponsor } from '../types';

export const friends: Sponsor[] = [
  {
    name: "SCAR",
    description: "Southern California Attack Robotics",
    logo: "/SCAR_flag-01.png",
    url: "https://www.socalattackrobots.com/"
  },
  {
    name: "Team 399: Eagle Robotics", 
    description: "FIRST Robotics Competition team from Lancaster, CA",
    logo: "https://images.squarespace-cdn.com/content/v1/633f8c74a926e51d5a8fd8bd/cff56738-1227-41ae-9af1-530922934082/White+Logo+-+Vertical+-+Eagle+Robotics.png?format=1500w",
    url: "https://www.team399.org/"
  },
  {
    name: "AH Designs", 
    description: "Motor wizard, yoyo champion, and Rival partner.",
    logo: "https://images.squarespace-cdn.com/content/v1/5e866b7fb3f9b94a8288b2f4/1592029840599-IH19UG6Z3YV85NCG3ZUZ/ahconcept.png?format=1500w",
    url: "https://www.alex-hattori.com/"
  },
  {
    name: "Balikbayan Bots", 
    description: "FIRST Robotics Competition team from Las Vegas, NV",
    logo: "/balikbayanbots.png",
    url: "https://www.balikbayanbots.com/"
  },
]; 